addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('driplen-verify');
  const input = document.getElementById('driplen-serial');
  const result = document.getElementById('driplen-result');

  if (!button || !input || !result) return;

  const validSerials = [
    'DRP-PRED-0001',
    'DRP-PRED-0002',
    'DRP-PRED-0003',
    'DRP-PRED-0004',
    'DRP-PRED-0005'
  ];

  button.addEventListener('click', function () {
    const serial = input.value.trim().toUpperCase();

    if (!serial) {
      result.textContent = 'Please enter a serial number.';
      return;
     }

  if (validSerials.includes(serial)) {
    result.textContent = '✓ AUTHENTIC DRIPLEN PRODUCT';
  } else {
    result.textContent = 'Serial number not recognized.';
  }
});
});

